import React from 'react';
import { useRecording } from './RecordingProvider';
import './ScreenRecorder.css';

/**
 * Trigger button for the app-level recording session. The actual capture, the
 * floating Stop control, the review modal, and the upload all live in
 * RecordingProvider so a recording survives navigating between pages.
 *
 * uploader: (file) => Promise — how the finished recording is saved (e.g. upload
 * as a case attachment). Hidden on browsers without screen-capture support.
 */
function ScreenRecorder({ uploader, disabled = false, label = 'Record screen' }) {
  const rec = useRecording();
  if (!rec || !rec.supported) return null;
  return (
    <button
      type="button"
      className="screen-recorder-btn"
      onClick={() => rec.start(uploader)}
      disabled={disabled || rec.active}
      title="Record your screen with microphone voiceover"
    >
      <span className="screen-recorder-rec-dot" aria-hidden /> {label}
    </button>
  );
}

export default ScreenRecorder;
